import { gql } from "@apollo/client";

const ACCEPT_REGISTRATION_INVITE = gql`
  mutation acceptRegistrationInvite($inviteId: ID!) {
    acceptRegistrationInvite(inviteId: $inviteId) {
      id
    }
  }
`;

export default ACCEPT_REGISTRATION_INVITE;
